import axios from 'axios';

//for local
//const API_BASE_URL = 'http://localhost:5000';
//for production
const API_BASE_URL = 'https://reseller-portal-web-apis.azurewebsites.net'
//for development
//const API_BASE_URL = 'https://reseller-portal-web-apis-development.azurewebsites.net'

// Create axios instance and export it
export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/login', { email, password }),
  
  // Super admin login (NEW)
  superAdminLogin: (email, password) => api.post('/super-admin/login', { email, password }),
  
  logout: () => api.post('/logout'),
  register: (email, password) => api.post('/register', { email, password }),
  changePassword: (passwordData) => api.post('/change-password', passwordData),
  // Export the axios instance for interceptor access
  axiosInstance: api
};

// Reseller API
export const resellerAPI = {
  getProfile: () => api.get('/profile'),
  getMyClients: () => api.get('/my-clients'),
  getClientOrders: () => api.get('/client-orders'),
  getAllProducts: () => api.get('/software-products'),
  createClient: (clientData) => api.post('/my-clients', clientData),
  createClientOrder: (orderData) => api.post('/client-orders', orderData),
  updateClient: (clientId, clientData) => api.put(`/my-clients/${clientId}`, clientData),
  deleteClient: (clientId) => api.delete(`/my-clients/${clientId}`),
  changePassword: (passwordData) => api.post('/change-password', passwordData),
  addResellerUser: (userData) => api.post('/reseller/users', userData),
};

// Super Admin API (NEW)
export const superAdminAPI = {
  getResellers: () => api.get('/super-admin/resellers/all'),  // Updated endpoint
  getClients: () => api.get('/super-admin/clients'),           // Correct endpoint
  getOrders: () => api.get('/super-admin/orders'),            // Correct endpoint
  getSoftwareProducts: () => api.get('/software-products'), // For super admin view
  createReseller: (resellerData) => api.post('/super-admin/resellers', resellerData),
  updateReseller: (resellerId, resellerData) => api.put(`/super-admin/resellers/${resellerId}`, resellerData),
  deleteReseller: (resellerId) => api.delete(`/super-admin/resellers/${resellerId}`),
  getSingleResellerid: (resellerId) => api.get(`/super-admin/resellers/${resellerId}`),
  
  // NEW: Client CRUD operations
  createClient: (clientData) => api.post('/super-admin/clients', clientData),
  updateClient: (clientId, clientData) => api.put(`/super-admin/clients/${clientId}`, clientData),
  deleteClient: (clientId) => api.delete(`/super-admin/clients/${clientId}`),
  getSingleClient: (clientId) => api.get(`/super-admin/clients/${clientId}`),
  getSingleReseller: (resellerId) => api.get(`/super-admin/resellersid/${resellerId}`),
  
  // Get resellers for dropdown
  getResellersForDropdown: () => api.get('/super-admin/resellers/all'),

  updateOrder: (orderId, orderData) => api.put(`/super-admin/orders/${orderId}`, orderData),
  deleteOrder: (orderId) => api.delete(`/super-admin/orders/${orderId}`),
  getSingleOrder: (orderId) => api.get(`/super-admin/orders/${orderId}`),
  
  // NEW: Reminder control endpoint
  controlOrderReminder: (orderId, data) => api.post(`/api/super-admin/orders/${orderId}/reminder-control`, data),
  getProductsForSerial: () => api.get('/super-admin/products-for-serial'),
  generateSerialNumber: (productName) => api.post('/super-admin/serial/generate', { product: productName }),

};

export default api;